<template>
  <div
    class="modal fade"
    id="modaDetailUser"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modaDetailUserLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="modaDetailUserLabel">Detail User</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeModal"
            @click="closeModal"
          ></button>
        </div>
        <div class="modal-body">
          <div class="d-lg-flex">
            <div class="col-lg-8">
              <div class="mb-2">
                <label for="exampleFormControlInput7">Principal</label>
                <select
                  class="form-select"
                  id="exampleFormControlInput7"
                  placeholder="Company"
                  v-model="newData.compcode"
                  disabled
                >
                  <option value="">====</option>
                  <option
                    :value="n.compcode"
                    v-for="(n, i) in listCompany"
                    :key="i"
                  >
                    {{ n.compname }}
                  </option>
                </select>
              </div>
              <div class="mb-2">
                <label for="exampleFormControlInput8">Nama lengkap</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput8"
                  placeholder="fullname"
                  v-model="newData.fullname"
                  :disabled="!statusEdit"
                />
              </div>
              <div class="mb-2">
                <label for="exampleFormControlInput9">Username</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput9"
                  placeholder="username"
                  v-model="newData.username"
                  :disabled="!statusEdit"
                />
              </div>
              <div class="mb-2">
                <label for="exampleFormControlInput10">Password</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput10"
                  placeholder="password"
                  v-model="newData.password"
                  :disabled="!statusEdit"
                />
              </div>
              <div class="mb-2">
                <label for="exampleFormControlInput11">Level</label>
                <select
                  class="form-select"
                  id="exampleFormControlInput11"
                  placeholder="Level"
                  v-model="newData.level"
                  disabled
                >
                  <option value="1">Administrator</option>
                  <option value="2">Marketing</option>
                  <option value="3">Principle</option>
                </select>
              </div>
            </div>
            <div class="col px-3">
              <div class="card">
                <div class="card-body">
                  <div class="mb-2">
                    <p style="font-size: 12px">Status User</p>
                    <p style="font-size: 12px; font-weight: 900">
                      {{ newData.statusaktif == 0 ? "Non Active" : "Active" }}
                    </p>
                  </div>
                  <div class="mb-2">
                    <p style="font-size: 12px">Last Login</p>
                    <p style="font-size: 12px; font-weight: 900">
                      {{ newData.lastlogin ? "-" : "-" }}
                    </p>
                  </div>
                  <div class="mb-2">
                    <p style="font-size: 12px">Last Logout</p>
                    <p style="font-size: 12px; font-weight: 900">
                      {{ newData.lastlogin ? "-" : "-" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            v-if="statusEdit"
            @click="cancelEdit"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            v-if="statusEdit"
            @click="saveEdit"
          >
            Save
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            v-if="!statusEdit"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="statusEdit = true"
            v-if="!statusEdit"
          >
            Edit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "UserDetailComponent",
  props: {
    userDetail: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      statusEdit: false,
      newData: {},
    };
  },
  watch: {
    userDetail() {
      this.newData = { ...this.userDetail };
    },
  },
  computed: {
    listCompany() {
      return this.$store.state.Company.listCompany;
    },
  },
  methods: {
    ...mapActions({
      updateUser: "Users/update",
    }),
    cancelEdit() {
      this.newData = { ...this.userDetail };
      this.statusEdit = false;
    },
    closeModal() {
      this.statusEdit = false;
      this.newData = {};
    },
    saveEdit() {
      this.updateUser(this.newData)
        .then(() => {
          const status = this.$store.state.Alert.isAlerts[0].status;
          if (!status) {
            this.statusEdit = true;
          } else {
            this.statusEdit = false;
          }
        })
        .catch(() => {
          this.statusEdit = false;
        });
    },
  },
};
</script>
